import {
    httpStoreProjectClinicalPresentations,
    HttpStoreProjectClinicalPresentationsPayload
} from '@/features/projects/http/projects.http'
import {QUERY_KEYS, queryClient} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useStoreClinicalPresentations = (
    urlParams: {projectId: string},
    options?: UseMutationOptions<unknown, AxiosError<ErrorResponseData>, HttpStoreProjectClinicalPresentationsPayload>
) => {
    return useMutation({
        ...options,
        mutationFn: (payload: HttpStoreProjectClinicalPresentationsPayload) =>
            httpStoreProjectClinicalPresentations({urlParams, payload}),
        // Refetch the project so the header progressStatus (backend-computed) reflects this change.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, urlParams.projectId]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
